<template>
<div id="secure">
    <TopMenu />
    <section class="main-content columns is-fullheight">
        <div class="container column is-12">
            <div class="section">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>
                <div class="card">
                    <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
                        <ul>
                            <li><a v-on:click="goDashboard()">Group Dashboard</a></li>
                            <li><a v-on:click="goGroupDashboardSingle()">{{ groupName }}</a></li>
                            <li class="is-active" v-if="positivePeriod == 1"><a href="#" aria-current="page">{{ displayPeriod }} {{ positiveName }} details for {{ todayDateDisplay}} </a></li>
                            <li class="is-active" v-if="positivePeriod == 2"><a href="#" aria-current="page">{{ positiveName }} details for {{ displayMonth}} {{ actionYear }} </a></li>
                        </ul>
                    </nav>
                </div><br/>
                    
                <div class="columns">
                    <div class="column one-half">
                        <div class="card">
                            <loading :active.sync="isLoading1" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                            <div class="card-header">
                                <p class="card-header-title" v-if="positivePeriod == 1">Select date: <datepicker @closed="getBehaviors(selectedDate,1)"  v-model="selectedDate" wrapper-class="datepicker" placeholder="Select Date" :value="todayDate" :class="$style.datepicker" calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker></p>
                                <p class="card-header-title" v-if="positivePeriod == 2">&nbsp;</p>
                                <div style="padding: 10px;">
                                    <a class="button is-info is-small" style="margin-left: 5px;" v-on:click="downloadAsExcel()">Download As Excel</a>
                                </div>
                                <b-select id="duration" name="duration" v-model="duration" class="header-input" @input="getBehaviors()"  v-if="positivePeriod == 2">
                                    <option selected value="1">January</option>
                                    <option selected value="2">February</option>
                                    <option selected value="3">March</option>
                                    <option selected value="4">April</option>
                                    <option selected value="5">May</option>
                                    <option selected value="6">June</option>
                                    <option selected value="7">July</option>
                                    <option selected value="8">August</option>
                                    <option selected value="9">September</option>
                                    <option selected value="10">October</option>
                                    <option selected value="11">November</option>
                                    <option selected value="12">December</option>
                                </b-select>
                                <b-select id="sortBy" name="sortBy" v-model="sortBy" class="header-input" @input="sortBehaviors()" v-if="positivePeriod == 2">
                                    <option selected value="0">Sort by dates</option>
                                    <option selected value="1">Sort by points</option>
                                </b-select>
                            </div>
                            <div class="card-content">
                                <div class="content">
                                    <div class="columns bottom-border">
                                        <div class="column">Student</div>
                                        <div class="column">Date &amp; Time</div>
                                        <div class="column" style="text-align: center;">Total Points <br/><b>{{ totalPoints }}</b></div>
                                        <div class="column">Remarks</div>
                                        <div class="column">Awarded by</div>
                                        <div class="column is-1" style="padding: 0px; padding-top: 5px;"><a class="button is-warning is-small" v-on:click="revokePoints()">Revoke</a></div>
                                    </div>

                                    <div class="columns top-border" v-for="(behavior) in sortBehaviors(behaviorList)" :key="behavior._id">
                                        <div class="column">{{ behavior.studentID.firstName }} </div>
                                        <div class="column">{{ displayDate(behavior.actionDate) }}, {{ behavior.actionTime }} </div>
                                        <div class="column">{{ behavior.points }} x {{ behavior.multiply }} = <b>{{ behavior.totalPoints }}</b></div>
                                        <div class="column">{{ displayInfo(behavior.dataType,behavior.remarks,behavior.status) }}</div>
                                        <div class="column">{{ behavior.teacherID.firstName }} {{ behavior.teacherID.lastName }}</div>
                                        <div class="column is-1"><center><input type="checkbox"  :value="setCheckedValue(behavior.dataType,behavior._id,behavior.studentID._id,behavior.actionDate)" :id="setCheckedValue(behavior.dataType,behavior._id,behavior.studentID._id,behavior.actionDate)" v-model="checkedIDs"></center></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
                

            </div>
        </div>

    </section>    
</div>
</template>

<script>
import TopMenu from '../TopMenu'
import axios from 'axios'
import "../public/style.scss";
import { ToastProgrammatic as Toast } from 'buefy'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Datepicker from 'vuejs-datepicker';

export default {
    name: "GroupPositiveDetails",
    components: {
        TopMenu,
        Loading,
        Datepicker
    },
    data() {
        return {
            groupID: '',
            groupName: '',
            positiveID: '',
            positiveName: '',
            positivePeriod: 0,
            displayPeriod: '',
            actionYear: 0,
            actionMonth: 0,
            displayMonth: '',
            actionDate: '',
            sortBy: 0,
            behaviorList: [],
            todayDateDisplay: '',
            isLoading1: false,
            duration: 0,
            selectedDate: '',
            todayDay : 0,
            todayMonth : 0,
            todayYear : 0,
            totalPoints: 0,
            checkedIDs: []
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    computed:{     
    },
    created() {
        var currentDate = new Date();
        var currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        var currentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        this.duration = currentMonth;
        this.displayMonth = this.displayMonthName(currentMonth)
        if (currentMonth < 10){
            currentMonth = "0" + currentMonth;
        }
        this.actionDate = currentDate.getFullYear() + "" + currentMonth + "" + currentDay;
        this.actionYear = currentDate.getFullYear()

        this.todayDateDisplay = currentDay + "/" + currentMonth + "/" + this.actionYear

        this.groupID = this.$store.getters.getViewGroupID;

        if (this.groupID.trim.length < 1){
            this.groupID = localStorage.getItem('VIEW_GROUP_ID')
        }

        this.groupName = this.$store.getters.getViewGroupName;

        if (this.groupName.trim.length < 1){
            this.groupName = localStorage.getItem('VIEW_GROUP_NAME')
        }

        this.positiveID = this.$store.getters.getPositiveBehaviorID;
        if (this.positiveID.trim.length < 1){
            this.positiveID = localStorage.getItem('POSITIVE_BEHAVIOR_ID')
        }

        this.positiveName = this.$store.getters.getPositiveBehaviorName;
        if (this.positiveName.trim.length < 1){
            this.positiveName = localStorage.getItem('POSITIVE_BEHAVIOR_NAME')
        }

        this.positivePeriod = this.$store.getters.getPositivePeriod;
        if (this.positivePeriod < 1){
            this.positivePeriod = localStorage.getItem('POSITIVE_PERIOD')
        }

        if (this.positivePeriod == 1){
            this.displayPeriod = "Daily"
        }else{
            this.displayPeriod = "Whole Year"
        }

        this.todayDay = currentDate.getDate()
        this.todayMonth = currentDate.getMonth()
        this.todayYear = currentDate.getFullYear()

    },
    mounted(){        
        this.$root.$emit('activeSideMenu',"Dashboard") 
        this.getBehaviors(this.actionDate,0)
    },
    methods: {
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        downloadAsExcel(){
            let self = this;
            var setDisplayDate = "";
            var duration = "daily";
            if (self.positivePeriod == 1){
                setDisplayDate = self.todayDateDisplay;
                duration = "daily"
            }else{
                setDisplayDate = self.displayMonth + " " + self.actionYear
                duration = "monthly"
            }
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + '/api/group/positive/details', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        positiveID: self.positiveID,
                        positiveName: self.positiveName,
                        groupID: self.groupID,
                        groupName: self.groupName,
                        duration: duration,
                        actionDate: self.actionDate,
                        actionMonth: self.duration,
                        actionYear: self.actionYear,
                        output: 'excel',
                        displayDate: setDisplayDate,
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.actionDate + "_positive_behavior.xlsx"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    self.isLoading1 = false;
                })
                .catch(e => {
                    console.log("228 Error:" + e)
                }) 
        },
        getBehaviors(actionDate,caller){

            if (caller == 1){   //called by datepicker
                var setActionDate = "";
                var setMonth = actionDate.getMonth() + 1;
                var setDay = actionDate.getDate();
                if (setMonth < 10){
                    setMonth = "0" + setMonth
                }
                if (setDay < 10){
                    setDay = "0" + setDay
                }
                setActionDate = actionDate.getFullYear() + setMonth + setDay
                actionDate = setActionDate
                this.actionDate = actionDate
            }else{
                //this.selectedDate = this.actionDate
                console.log("year: " + this.todayYear + " day: " + this.todayDay + " mo: " + this.todayMonth)
                this.selectedDate = new Date(this.todayYear, this.todayMonth,this.todayDay )
            }
            
            let self = this;
            self.isLoading1 = true;

            if (self.positivePeriod == 1){  //only for today
                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')            
                axios.defaults.responseType = 'json'
                axios.post(process.env.MY_URL + '/api/group/positive/details', {
                        params: {
                            email: localStorage.getItem('email'),
                            sessionID: localStorage.getItem('sessionID'),
                            positiveID: self.positiveID,
                            positiveName: self.positiveName,
                            groupID: self.groupID,
                            groupName: self.groupName,
                            duration: "daily",
                            actionDate: actionDate
                        }
                    })
                    .then(response => {
                        console.log("imin 270: ")
                        console.log(response.data)
                        self.behaviorList = response.data
                        self.isLoading1 = false;
                        self.totalPoints = 0
                        for (var i = 0; i < self.behaviorList.length; i++){
                            self.totalPoints = self.totalPoints + self.behaviorList[i].totalPoints;
                        }
                    })
                    .catch(e => {
                        console.log("181 Error:" + e)
                    }) 
                    
            }else{  //for the current month
                this.displayMonth = this.displayMonthName(self.duration)
                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')            
                axios.defaults.responseType = 'json'
                axios.post(process.env.MY_URL + '/api/group/positive/details', {
                        params: {
                            email: localStorage.getItem('email'),
                            sessionID: localStorage.getItem('sessionID'),
                            positiveID: self.positiveID,
                            positiveName: self.positiveName,
                            groupID: self.groupID,
                            groupName: self.groupName,
                            duration: "monthly",
                            actionMonth: self.duration,
                            actionYear: self.actionYear
                        }
                    })
                    .then(response => {
                        self.behaviorList = response.data
                        console.log("304 response.data")
                        console.log(response.data)
                        self.isLoading1 = false;
                        self.totalPoints = 0
                        for (var i = 0; i < self.behaviorList.length; i++){
                            self.totalPoints = self.totalPoints + self.behaviorList[i].totalPoints;
                        }
                    })
                    .catch(e => {
                        console.log("206 Error:" + e)
                    }) 
            }
        },
        sortBehaviors(arrays){
            if (this.sortBy == 1){  //points
                return _.orderBy(arrays, 'totalPoints', 'desc');  //we're using the magical lodash function here
            }else{  //dates
                return _.orderBy(arrays, 'actionDate', 'desc');  //we're using the magical lodash function here
            }            
        },
        setCheckedValue(dataType,id,studentID,actionDate){
            return "1:" + dataType + "|2:" + id + "|3:" + studentID + "|4:" + actionDate
        },
        displayDate(date){
            try{
                var getYear = date.substring(0,4);
                var getMonth = date.substring(4,6);
                var getDay = date.substring(6);

                return getDay + "/" + getMonth + "/" + getYear;
            }catch(err){
                console.log(err)
                return date;
            }
        },
        displayInfo(dataType,remarks,status){
            if (dataType == 2){
                if (status == 2){
                    return "Late"
                }else{
                    return "On-Time"
                }
            }else{
                return remarks
            }
        },
        goGroupDashboardSingle(){
            this.$store.commit('UPDATE_VIEW_GROUP_ID',this.groupID)
            this.$store.commit('UPDATE_VIEW_GROUP_NAME',this.groupName)
            localStorage.setItem('VIEW_GROUP_ID',this.groupID)
            localStorage.setItem('VIEW_GROUP_NAME',this.groupName)

            this.$router.push({
                name: "GroupDashboardSingle"
            });
        },
        goDashboard(){
            this.$router.push({
                name: "GroupDashboard"
            });
        },     
        revokePoints(){
            var pointsToRevoke = this.checkedIDs;
            if (pointsToRevoke.length > 0){
                
                var r = confirm("Are you sure you want to revoke the selected points?");
                if (r == true){
                    let self = this;
                    self.isLoading1 = true;
                    axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                    axios.defaults.responseType = 'json'
                    axios.post(process.env.MY_URL + '/api/students/positives/revoke_multiple', {
                            params: {
                                email: localStorage.getItem('email'),
                                sessionID: localStorage.getItem('sessionID'),
                                pointsToRevoke: pointsToRevoke,
                            }
                        })
                        .then(response => {
                            self.isLoading1 = false;
                            //reload the behaviors
                            this.getBehaviors(this.actionDate,0)

                            Toast.open({
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            }) 
                        })
                        .catch(e => {
                            console.log("277 Error:" + e)
                        }) 
                }
            }else{
                alert("Please select the behavior(s) you want to revoke first.")
                return false;
            }
            
        },
        // revokePoints(data){

        //     var r = confirm("Are you sure you want to revoke this points?");
        //     if (r == true){                
        //         const dataIndex = this.behaviorList.indexOf(data);
        //         this.behaviorList.splice(dataIndex, 1);

        //         let self = this;
        //         self.isLoading1 = true;
        //         axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
        //         axios.defaults.responseType = 'json'
        //         axios.post(process.env.MY_URL + '/api/students/positives/revoke', {
        //                 params: {
        //                     email: localStorage.getItem('email'),
        //                     sessionID: localStorage.getItem('sessionID'),
        //                     studentID: data.studentID._id,
        //                     awardedID: data._id,
        //                 }
        //             })
        //             .then(response => {
        //                 console.log("imin 266: ")
        //                 console.log(response.data)
        //                 self.studentList = response.data
        //                 self.isLoading1 = false;

        //                 self.behaviorList.splice(index, 1);
        //             })
        //             .catch(e => {
        //                 console.log("277 Error:" + e)
        //             }) 
        //     }
            
        // },
        displayMonthName(month){
            var monthDisplay = "";
            switch (parseInt(month)){
                case 1:
                    monthDisplay = "January";
                    break;
                case 2:
                    monthDisplay = "February";
                    break;
                case 3:
                    monthDisplay = "March";
                    break;
                case 4:
                    monthDisplay = "April";
                    break;
                case 5:
                    monthDisplay = "May";
                    break;
                case 6:
                    monthDisplay = "June";
                    break;
                case 7:
                    monthDisplay = "July";
                    break;
                case 8:
                    monthDisplay = "August";
                    break;
                case 9:
                    monthDisplay = "September";
                    break;
                case 10:
                    monthDisplay = "October";
                    break;
                case 11:
                    monthDisplay = "November";
                    break;
                case 12:
                    monthDisplay = "December";
                    break;
                default:
                    monthDisplay = "January";
                    break;
            }
            return monthDisplay;
        }
    }
};
</script>

<style scoped>
.kelas-button{
    margin-right: 10px;
    margin-bottom: 10px;
}
.header-tag{
    margin-left: 10px;
    border: 1px solid #209cee;
    color: #209cee;
    padding-bottom: calc(0.375em - 1px);
    padding-left: 0.75em;
    padding-right: 0.75em;
    padding-top: calc(0.375em - 1px);
    align-items: center;
    border-radius: 4px;
    font-size: 1rem;
    height: 2.25em;
    line-height: 1.5;
    margin: 10px;
}
.header-button{
    margin-top: 10px;
    margin-left: 10px;
}
.top-border{
    border-top: 1px solid #CCC
}
.right-border{
    border-right: 1px solid #CCC
}
.bottom-border{
    border-bottom: 1px solid #CCC
}
.text-center{
    text-align: center;
}
.header-input{
    margin: 10px;
}
.breadcrumb{
    padding: 10px;
}
.datepicker{
    margin-left: 30px;
}
</style>
<style module>
.datepicker input{
    border: none; /* <-- This thing here */
    border:1px solid #1849c8;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/Group/PositiveDetails.vue